import { isSuccess } from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { FeaturedService, FormattedServices } from '@/models/service'
import { BookingAvailability } from '@/store/bookingAvailabilitySlice'
import { servicesSlice } from '@/store/servicesSlice'
import { getServiceKeyFromId } from '@/utils/serviceIdKeyUtils'
import { cartSlice } from '..'

export const availableFeaturedServicesSelector = createSelector(
  [
    servicesSlice.selectors.featuredServices,
    servicesSlice.selectors.data,
    cartSlice.selectors.cartReservations,
    cartSlice.selectors.selectedBookingType,
  ],
  (
    featuredServices,
    services,
    cartReservations,
    selectedBookingType
  ): FeaturedService[] => {
    if (selectedBookingType === BookingAvailability.TICKETS) {
      return isSuccess(featuredServices) ? featuredServices.value : []
    }
    const extraFeaturedServices = services?.extraFeaturedServices ?? []
    // FIXME: cartReservations are not-nullable but somehow it's arriving undefined
    const cartReservationsSectors =
      cartReservations?.map((reservation) => reservation.sectorId) ?? []
    return extraFeaturedServices?.filter((service) =>
      service.sectors.some((sector) => cartReservationsSectors.includes(sector))
    )
  }
)

export const formattedServicesSelector = createSelector(
  [availableFeaturedServicesSelector],
  (featuredExtraServices): FormattedServices => {
    return featuredExtraServices.reduce<
      Record<string, { sectors: number[]; id: number }>
    >((acc, item) => {
      const key = getServiceKeyFromId(item.serviceId)
      return {
        ...acc,
        [key]: {
          id: item.serviceId,
          sectors: item.sectors,
        },
      }
    }, {})
  }
)
